module.exports = __webpack_public_path__ + "img/dark-logo.94c8cb46.gif";